import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { getCategoryUrl } from "@/lib/contentful/categoryUrl";
import type { TypeBlogCategorySkeleton } from "@/types/contentful/generated";
import { CategoryLabel } from "./CategoryLabel";
interface Props {
  categories: Entry<TypeBlogCategorySkeleton, undefined, string>[];
  draftMode?: boolean;
}
export const CategoryTree = t0 => {
  const $ = _c(7);
  const {
    categories,
    draftMode
  } = t0;
  const byName = _temp;
  let t1;
  let t2;
  if ($[0] !== categories || $[1] !== draftMode) {
    const parentCategories = categories.filter(_temp2).sort(byName);
    const childCategories = categories.filter(_temp3);
    const childrenByParent = childCategories.reduce(_temp4, {} as Record<string, Entry<TypeBlogCategorySkeleton, undefined, string>[]>);
    for (const id of Object.keys(childrenByParent)) {
      childrenByParent[id].sort(byName);
    }
    const renderCategory = (category, t3) => {
      const level = t3 === undefined ? 0 : t3;
      const children = childrenByParent[category.sys.id] || [];
      const blogCount = category.fields.blogPostCount || 0;
      if (blogCount === 0) {
        return null;
      }
      return <li key={category.sys.id} className="ml-0"><CategoryLabel name={category.fields.name} count={blogCount} href={getCategoryUrl(category)} bold={level === 0} draftMode={draftMode} />{children.length > 0 && <ul className="flex flex-col gap-2 ml-4 mt-2">{children.map(child_0 => renderCategory(child_0, level + 1))}</ul>}</li>;
    };
    t1 = "flex flex-col gap-2 text-sm px-6";
    t2 = parentCategories.map(parent => renderCategory(parent));
    $[0] = categories;
    $[1] = draftMode;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(a, b) {
  const nameA = a.fields.name || "";
  const nameB = b.fields.name || "";
  return nameA.localeCompare(nameB);
}
function _temp2(cat) {
  return !cat.fields.parentCategory;
}
function _temp3(cat_0) {
  return cat_0.fields.parentCategory;
}
function _temp4(acc, child) {
  const parentCategory = child.fields.parentCategory;
  if (!parentCategory || !("fields" in parentCategory)) {
    return acc;
  }
  const parentId = parentCategory.sys.id;
  if (!acc[parentId]) {
    acc[parentId] = [];
  }
  acc[parentId].push(child);
  return acc;
}